// extracted by mini-css-extract-plugin
module.exports = {"initiativesDashboardHeader":"InitiativesDashboardHeader_initiativesDashboardHeader__3FFu-","title":"InitiativesDashboardHeader_title__whIDe"};